import React, { Component } from "react";

import "component/game/GameFrame/styles.scss";

class GameFrame extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isCollapsed: true,
      isLiked: false,
    };
  }

  render() {
    return (
      <div className={this.props.className}>
        <div
          className={`gameFrameContainer ${
            this.props.isFullHeight ? "full-height" : ""
          }`}
          ref="GAME_CONTAINER"
        >
          {this.props.src && (
            <iframe
              title="Game"
              className="gameFrame"
              src={this.props.src}
              frameBorder="0"
              height="1200"
              scrolling="yes"
            />
          )}
        </div>
      </div>
    );
  }
}

export default GameFrame;
